export default "__VITE_ASSET__CjJ2xYrO__"